<template>
<div>
    <div class="embed-container">
         <iframe
            frameborder="0"
            allowfullscreen="1"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            width="100%"
            height="100%"
            type="text/html"
            :src="'https://www.youtube.com/embed/'+video_link+'?autoplay=1&controls=1&disablekb=1&playsinline=1&cc_load_policy=0&cc_lang_pref=auto&widget_referrer=https%3A%2F%2Fwww.mymedisage.com%2FliveEvent%2Fdemocd&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1&customControls=true&noCookie=false&enablejsapi=1&origin=https%3A%2F%2Fwww.mymedisage.com&widgetid=1'"></iframe>
    </div>
</div>
</template>

<script>
export default {
    props : ['video_link'],
    data() {
        return {
            data : this.$attrs,
        }
    },
}
</script>
